module.exports = __webpack_public_path__ + "media/images/categories/headers/media-b3fdbe794dd5cc10be67b0499fde6e42.jpg";